import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import map from 'lodash/map';

import { ChevronRightIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

const Breadcrumbs = ({ className, breadcrumbs }) => (
  <div className={classNames('breadcrumbs', className)}>
    {
      map(breadcrumbs, ({ content, onClick }, idx) => {
        const isLastCrumb = idx === breadcrumbs.length - 1;

        return (
          <Fragment key={`${content}-${idx}`}>
            <span
              onClick={isLastCrumb ? null : onClick}
              className={classNames('crumb', {
                'is-last-crumb': isLastCrumb
              })}
            >
              { content }
            </span>

            { !isLastCrumb && <ChevronRightIcon key="sep" className="crumb-sep" /> }
          </Fragment>
        );
      })
    }
  </div>
);

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
      PropTypes.func
    ]).isRequired,
    onClick: PropTypes.func
  })).isRequired
};

export default Breadcrumbs;
